import Link from 'next/link'

export function QuestionPartnership() {
  return (
    <section>
      <div className="mx-auto px-6 xl:px-0 pt-16 pb-16 text-center lg:pt-32 lg:pb-32 lg:max-w-[1200px]">
        <h2 className="text-lg font-bold text-textblack text-center lg:text-4xl font-feature-settings">
          よくあるご質問
        </h2>

        <div className="mt-4 lg:mt-12 accordion_wrap">
          <div className="border rounded-lg border-solid border-gray bg-white">
            <div data-accordion-title="true" className="accordion__head">
              <div className="flex items-center py-3 px-5 cursor-pointer">
                <div className="text-4xl font-robot font-medium text-primary">
                  Q
                </div>
                <div className="ml-5 w-[93%] text-base text-left">
                  手数料、仕切り価格について教えてください
                </div>
                <span className="w-[36px]">
                  <img
                    decoding="async"
                    src="/images/img_accordion_close.svg"
                    alt="Close"
                    className="w-full img_flag"
                  />
                </span>
              </div>
            </div>
            <div
              className="transition-all overflow-hidden max-h-0 accordion_body_0 accordion_body_wrap"
              aria-hidden="true"
            >
              <div className="accordion__body">
                <div className="flex items-start px-5 pt-3 pb-5">
                  <div className="text-4xl font-robot font-medium text-textblack">
                    A
                  </div>
                  <div className="ml-4 text-base text-left pt-[14px]">
                    パートナー形態により異なって参りますので、是非一度お打ち合わせをさせていただけますと幸いです。
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-2 border rounded-lg border-solid border-gray bg-white">
            <div data-accordion-title="true" className="accordion__head">
              <div className="flex items-center py-3 px-5 cursor-pointer">
                <div className="text-4xl font-robot font-medium text-primary">
                  Q
                </div>
                <div className="ml-5 w-[93%] text-base text-left">
                  サービスの初期費用や利用料はいくらでしょうか？
                </div>
                <span className="w-[36px]">
                  <img
                    decoding="async"
                    src="/images/img_accordion_close.svg"
                    alt="Close"
                    className="w-full img_flag"
                  />
                </span>
              </div>
            </div>
            <div
              className="transition-all overflow-hidden max-h-0 accordion_body_0 accordion_body_wrap"
              aria-hidden="true"
            >
              <div className="accordion__body">
                <div className="flex items-start px-5 pt-3 pb-5">
                  <div className="text-4xl font-robot font-medium text-textblack">
                    A
                  </div>
                  <div className="ml-4 text-base text-left pt-[14px]">
                    ID数や諸条件によって変動しますので、詳細は直接お問い合わせください。
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-[0.5rem] border rounded-lg border-solid border-gray bg-white">
            <div data-accordion-title="true" className="accordion__head">
              <div className="cursor-pointer flex items-center py-3 px-5">
                <div className="text-4xl font-robot font-medium text-primary">
                  Q
                </div>
                <div className="w-[93%] text-base text-left ml-5">
                  パートナーになるための契約金や初期費用はありますか？
                </div>
                <span className="w-[36px]">
                  <img
                    decoding="async"
                    src="/images/img_accordion_close.svg"
                    alt="Close"
                    className="w-full img_flag"
                  />
                </span>
              </div>
            </div>
            <div
              className="transition-all overflow-hidden max-h-0 accordion_body_0 accordion_body_wrap"
              aria-hidden="true"
            >
              <div className="accordion__body">
                <div className="flex items-start pt-3 pb-5 px-5">
                  <div className="text-4xl font-robot font-medium text-textblack">
                    A
                  </div>
                  <div className="ml-4 text-base text-left pt-[14px]">
                    契約にあたりパートナー様から頂戴する費用はございません。
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-[0.5rem] border rounded-lg border-solid border-gray bg-white">
            <div data-accordion-title="true" className="accordion__head">
              <div className="cursor-pointer flex items-center py-3 px-5">
                <div className="text-4xl font-robot font-medium text-primary">
                  Q
                </div>
                <div className="w-[93%] text-base text-left ml-5">
                  どのようなお客さまがターゲットとなりますか？
                </div>
                <span className="w-[36px]">
                  <img
                    decoding="async"
                    src="/images/img_accordion_close.svg"
                    alt="Close"
                    className="w-full img_flag"
                  />
                </span>
              </div>
            </div>
            <div
              className="transition-all overflow-hidden max-h-0 accordion_body_0 accordion_body_wrap"
              aria-hidden="true"
            >
              <div className="accordion__body">
                <div className="flex items-start pt-3 pb-5 px-5">
                  <div className="text-4xl font-robot font-medium text-textblack">
                    A
                  </div>
                  <div className="ml-4 text-base text-left pt-[14px]">
                    LAWGUEは業種問わず幅広いお客様にご利用頂いているクラウドサービスとなっております。パートナー様の得意領域などをヒアリングした上で、最適なご提案が出来る様にサポートもさせていただいております。
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-2 border rounded-lg border-solid border-gray bg-white">
            <div data-accordion-title="true" className="accordion__head">
              <div className="flex items-center py-3 px-5 cursor-pointer">
                <div className="text-4xl font-robot font-medium text-primary">
                  Q
                </div>
                <div className="ml-5 w-[93%] text-base text-left">
                  商談のサポートはしてくれますか？
                </div>
                <span className="w-[36px]">
                  <img
                    decoding="async"
                    src="/images/img_accordion_close.svg"
                    alt="Close"
                    className="w-full img_flag"
                  />
                </span>
              </div>
            </div>
            <div
              className="transition-all overflow-hidden max-h-0 accordion_body_0 accordion_body_wrap"
              aria-hidden="true"
            >
              <div className="accordion__body">
                <div className="flex items-start px-5 pt-3 pb-5">
                  <div className="text-4xl font-robot font-medium text-textblack">
                    A
                  </div>
                  <div className="ml-4 text-base text-left pt-[14px]">
                    もちろんご契約間もない期間など、商談サポートをさせていただきます。またパートナー様のオンボーディングサポートや各種トレーニングもさせていただきますのでお気軽にご相談いただくことが可能です。
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-2 border rounded-lg border-solid border-gray bg-white">
            <div data-accordion-title="true" className="accordion__head">
              <div className="flex items-center py-3 px-5 cursor-pointer">
                <div className="text-4xl font-robot font-medium text-primary">
                  Q
                </div>
                <div className="ml-5 w-[93%] text-base text-left">
                  具体的なパートナー契約の流れについて教えてください
                </div>
                <span className="w-[36px]">
                  <img
                    decoding="async"
                    src="/images/img_accordion_close.svg"
                    alt="Close"
                    className="w-full img_flag"
                  />
                </span>
              </div>
            </div>
            <div
              className="transition-all overflow-hidden max-h-0 accordion_body_0 accordion_body_wrap"
              aria-hidden="true"
            >
              <div className="accordion__body">
                <div className="flex items-start px-5 pt-3 pb-5">
                  <div className="text-4xl font-robot font-medium text-textblack">
                    A
                  </div>
                  <div className="ml-4 text-base text-left pt-[14px]">
                    ページ上部の「ご契約までの流れ」をご参照ください
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
